<template>
  <div class="hidden"></div>
</template>

<script>
export default {
  name: 'SessionTabs',
  data() {
    return {
      tabs: [
        { id: 'session_overview', step: '1', name: 'Overview', href: '#', current: true },
        { id: 'session_details', step: '2', name: 'Details', href: '#', current: false },
        // {id: 'session_preparation', step: '3' name: "Preparation", href: "#", current: false},
      ],
    };
  },
  methods: {
    tabState(id) {
      this.tabs.forEach((tab) => {
        tab.current = tab.id === id;
      });
    },
  },
};
</script>

<style scoped></style>
